import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, noindex = false }) => (
  <Helmet>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    {noindex && <meta name="robots" content="noindex, nofollow" />}
  </Helmet>
);
